import { KeyboardShortcut } from '../context/VideoPlayerProvider';

export const VIDEO_SHORTCUTS: KeyboardShortcut[] = [
  { key: 'Space', description: 'Play / Pause' },
  { key: 'k', description: 'Play / Pause' },
  { key: 'f', description: 'Toggle fullscreen' },
  { key: 'c', description: 'Toggle captions' },
  { key: '+', description: 'Increase playback speed' },
  { key: '-', description: 'Decrease playback speed' },
  { key: '0-9', description: 'Seek 0% - 90%' },
  { key: 'left', description: 'Backward 10s', isIcon: true },
  { key: 'right', description: 'Forward 10s', isIcon: true },
  { key: 'up', description: 'Increase volume', isIcon: true },
  { key: 'down', description: 'Decrease volume', isIcon: true },
];
